import { useTranslation } from "react-i18next";
import { Button, Icon, Modal } from "semantic-ui-react";

import "modules/KeyLockersDashboard/components/KeyLockerBoxesModal/components/KeyLockerBoxPinModal/KeyLockerBoxPinModal.scss";

type KeyLockerBoxPinModalProps = {
  isOpen: boolean;
  pinNumber?: string;
  onClose: () => void;
};

export const KeyLockerBoxPinModal = ({ isOpen, onClose, pinNumber }: KeyLockerBoxPinModalProps) => {
  const { t } = useTranslation();

  if (!pinNumber) return null;

  return (
    <Modal open={isOpen} closeOnDimmerClick onClose={onClose} className="KeyLockerBoxPinModal">
      <Modal.Header className="header-container">
        <div className="header-button-container">
          {t("v8_pin_number", "Pin Number")}

          <Button className="modal-close-btn" basic onClick={onClose}>
            <Icon className="xmark" />
          </Button>
        </div>
      </Modal.Header>
      <Modal.Content>
        <div className="content-container">
          <span className="text">
            {`${t(
              "v8_go_to_the_key_locker_and_use_this_pin_as_if_you_wanted_to_pick_up_a_key_it_will_expire_in_5_minutes",
              "Go to the key locker and use this PIN as if you wanted to pick up a key, it will expire in 5 minutes"
            )}: ${pinNumber} `}
          </span>
        </div>
      </Modal.Content>
    </Modal>
  );
};
